<template>
  <div>
    <v-stepper-step :complete="currentStep > 2" step="2">
      <h3>Step 2</h3>
      <small style="padding-top:5px;">Details of recipient (Address where notification was posted)</small>
      <div v-show="currentStep == 2" class="text-caption">
        <p>
          <span class="red--text"><strong>* </strong></span>= Mandatory field
        </p>
      </div>
    </v-stepper-step>
    <v-stepper-content step="2">
      <v-form v-model="recipientFormValid">
        <v-container fluid>
          <div class="input-wrapper">
            <input id="stuff" hidden />
            <label for="stuff" class="fa fa-exclamation input-icon"></label>
          </div>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.name" :rules="nameRules" :counter="14" label="RecipientName"
              placeholder="Customer Name" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>Customer Name:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.surname" :rules="surnameRules" :counter="20" label="RecipientSurname"
              placeholder="Customer Surname" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>Customer Surname:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.companyName" :rules="companyNameRules" :counter="100"
              label="RecipientCompanyName" placeholder="Company Name">
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"></span>Company Name:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4" v-if="recipient.companyName">
            <v-text-field v-model="recipient.vatNumber" :rules="vatNumberRules" label="RecipientVATNumber"
              placeholder="VAT Number" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>VAT Number:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <template>
            <v-subheader class="pl-0">
              Search for your address using the address finder or enter it
              manually below.
            </v-subheader>
            <v-card class="mb-4">
              <v-card-text class="py-0">
                <v-autocomplete v-model="selectedAddress" input="selectedAddress" :items="addressItems"
                  :loading="isLoadingAddressData" :search-input.sync="search" :menu-props="autocompleteMenuProps"
                  hide-no-data item-text="Description"
                  placeholder="Search by Postcode, Locality, House number, House name, etc..."
                  prepend-icon="mdi-magnify" return-object></v-autocomplete>
              </v-card-text>
            </v-card>
          </template>

          <v-col cols="12" md="4">
            <v-autocomplete :items="localities" label="Locality" item-text="name" item-value="id"
              placeholder="Select a locality" v-model="recipient.localityId" required :rules="localityRules"
              @change="updateRecipientAddressLocality">
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>Locality:
                </h3>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.streetName" :rules="streetNameRules" :counter="50"
              label="RecipientStreetName" placeholder="Street Name" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>Street Name:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.houseNameNumber" :rules="houseNameNumberRules" :counter="50"
              label="RecipientHouseNameNumber" placeholder="House Name / Number" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>House Name / Number:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.postCode" :rules="postCodeRules" label="RecipientPostCode"
              placeholder="Post Code" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>Post Code:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-autocomplete :items="countries" item-text="dialingCode" item-value="id" placeholder="Country Dialing Code"
              v-model="recipientPhoneCountryDialingCodeObject" return-object :rules="dialingCodeRules" :filter="customCountryDialingCodeSearch" required>
                <template slot="selection" slot-scope="data">
                  +{{ data.item.dialingCode }}
                </template>      
                <template slot="item" slot-scope="data">
                  {{ data.item.name }} (+{{ data.item.dialingCode }})
                </template>    
                <template #label>
                  <h3 class="black--text">
                    <span class="red--text"><strong>* </strong></span>Mobile / Telephone Number:
                  </h3>
                </template>  
            </v-autocomplete>

            <v-text-field v-model="recipient.phoneNumber" :rules="phoneRules" type="tel" style="padding-top:0"
              placeholder="Mobile / Telephone Number" required>        
            </v-text-field>

          </v-col>

          <v-col cols="12" md="4">
            <v-text-field v-model="recipient.email" :rules="emailRules" label="RecipientEmail" type="email"
              placeholder="E-mail address" required>
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>E-mail Address:
                </h3>
              </template>
            </v-text-field>
          </v-col>

        </v-container>
      </v-form>
      <v-btn color="primary" @click="goNext()" :disabled="!recipientFormValid">
        Next
      </v-btn>
      <v-btn text @click="currentStep = 1"> Back </v-btn>
    </v-stepper-content>
  </div>
</template>

<style>

</style>

<script>
import validationRules from "../../helpers/ValidationRules";
import axios from "axios";
import { combineURLs } from "../../helpers/UrlHelpers";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapMissedDeliveryGetters } = createNamespacedHelpers(
  "missedDelivery"
);

export default {
  name: "Step02",
  data() {
    return {
      ...validationRules,
      dataPreloadedFromDb: false,
      recipient: {
        name: "",
        surname: "",
        companyName: "",
        vatNumber: "",
        locality: null,
        localityId: null,
        streetName: "",
        houseNameNumber: "",
        postCode: "",
        phoneCountryDialingCode: 356,
        phoneNumber: "",
        email: ""
      },
      addressSearchResults: [],
      search: null,
      selectedAddress: null,
      isLoadingAddressData: false,
      recipientFormValid: false,
      recipientPhoneCountryDialingCodeObject: {}
    };
  },
  computed: {
    ...mapMissedDeliveryGetters({
      localities: "localities", 
      countries: "countries",
      loadedRecipient: "Step02/recipient"    
    }),
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("missedDelivery/setCurrentStep", currentStep);
      },
      get() {
        const stepNumber = this.$store.getters["missedDelivery/currentStep"];
        return stepNumber;
      },
    },
    addressItems() {
      return this.addressSearchResults.map((entry) => {
        var addrLine1 = [
          entry.houseNo,
          entry.houseName,
          entry.houseAlpha,
          entry.flatNo,
        ]
          .join(" ")
          .trim();
        var Description =
          addrLine1 +
          ", " +
          entry.street +
          ", " +
          entry.locality +
          " " +
          entry.postCode +
          ", " +
          entry.country;
        return Object.assign({}, entry, { Description, addrLine1 });
      });
    },
    autocompleteMenuProps() {
      // default properties copied from the vuetify-autocomplete docs
      let defaultProps = {
        closeOnClick: false,
        closeOnContentClick: false,
        disableKeys: true,
        openOnClick: false,
        maxHeight: 304,
        offsetY: true,
        offsetOverflow: true,
        transition: false,
      };

      if (this.$vuetify.breakpoint.smAndDown) {
        defaultProps.maxHeight = 185;
      }

      return defaultProps;
    },
  },
  watch: {
    countries() {
      if (this.countries.length > 0) {
        this.recipientPhoneCountryDialingCodeObject = this.countries.find(c => c.dialingCode == 356)
      }
    },
    loadedRecipient() {
      if (Object.keys(this.loadedRecipient).length !== 0 && !this.dataPreloadedFromDb) {
        this.recipient = { ...this.loadedRecipient }; //make a "deep" copy
        this.dataPreloadedFromDb = true;
      }
    },  
    search(val) {
      if (!val) {
        this.addressSearchResults = [];
      } else if (
        !this.isLoadingAddressData &&
        (this.selectedAddress == null ||
          val != this.selectedAddress.Description)
      ) {
        setTimeout(() => {
          var url = combineURLs(
            process.env.VUE_APP_ADDRESS_FINDER_API_BASE_URL,
            `/v1/address/search?query=${this.search}&maxresult=15`
          );
          axios
            .get(url)
            .then((res) => {
              this.addressSearchResults = res.data;
            })
            .catch((err) => {
              console.log(err);
              this.addressSearchResults = [];
            })
            .finally(() => (this.isLoadingAddressData = false));
        }, 1500);

        this.isLoadingAddressData = true;
      }
    },
    selectedAddress(newSelectedAddress) {
      if (newSelectedAddress != null) {

        this.recipient.houseNameNumber = newSelectedAddress.addrLine1;
        this.recipient.streetName = newSelectedAddress.street;
        this.recipient.postCode = newSelectedAddress.postCode;

        var selectedLocality = this.localities.find(function (l) {
          return l.localityNameOnly.toUpperCase() === newSelectedAddress.locality.toUpperCase() && l.region.toUpperCase() === newSelectedAddress.country.toUpperCase();        });
        if (selectedLocality) {
          this.recipient.localityId = selectedLocality.id;
          this.recipient.locality = selectedLocality.name;
        }
      }
    },
  },
  methods: {
    goNext() {
      this.recipient.phoneCountryDialingCode = this.recipientPhoneCountryDialingCodeObject.dialingCode;

      this.$store.dispatch("missedDelivery/Step02/setRecipient", this.recipient);

      this.$store.dispatch("missedDelivery/setCurrentStep", 3);
    },
    updateRecipientAddressLocality(localityId) {
      var locality = this.localities.find(function (l) { return l.id === localityId; });
      this.recipient.locality = locality.name;
    },
    customCountryDialingCodeSearch(item, queryText) {
      const data = "+" + item.dialingCode + item.name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return data.indexOf(searchText) > -1 
    }
  }
};
</script>